// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"d8359680","70":"5eded60f","312":"63117f02","777":"53433009"}[chunkId] + ".chunk.js";
};